import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import {
  BackResponse,
  BackResponseFailure,
  SellerSummary,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.config}sellers/byid/${COMMON_QUERY_PARAMS.SELLER_ID}`;

export interface GetSellerByIdQueryArgs {
  sellerId: string;
}

export const getSellerByIdRequest = ({
  sellerId,
}: GetSellerByIdQueryArgs): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId),
  config: { method: SUPPORTED_METHODS.GET },
});

export const getSellerByIdQuery = async ({
  sellerId,
}: GetSellerByIdQueryArgs): Promise<
  BackResponse<SellerSummary> | BackResponseFailure
> => {
  try {
    return await executeQuery<BackResponse<SellerSummary>>(
      getSellerByIdRequest({ sellerId }),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
